class VwMuracaatAramaDTO {
    id: number = 0;
    kimlikId?: number = null;
    adi?: string = "";
    soyadi?: string = "";
    kimlikNo?: string = "";
    babaAdi?: string = "";
    anaAdi?: string = "";
    dogumYeri?: string = "";
    dogumTarihi?: string = null;
    adres?: string = "";
    servisId?: number = null;
    doktorId?: number = null;
    tarih?: string = null;
    kurumId?: number = null;
    organizasyonId?: number = null;
    aileAdi?: string = "";
    pasaportNo?: string = "";
    treekey?: string = "";
    bagliOrganizasyonId?: number = null;
    kurumprotokolno?: string = "";
    biyopsiNo?: string = "";
}
export default VwMuracaatAramaDTO;